import type { RouteDef } from '../router';
import { ssrBodyFor, browserPath } from '../router';

/**
 * /regions/esim-:region — SPA side of the 9 regional hubs (audit 2.1).
 * SSR body: backend/src/util/region-body.ts (live tables from prices.json).
 * Idempotent render — see the agent-landing reload-loop lesson (2026-07-07).
 */
const NAV_GUARD_KEY = 'roamzy:region-nav';

export const regionRoute: RouteDef = {
  path: '/regions/:slug',
  routeType: 'article',
  metaTitle: 'eSIM by Region — Live Per-MB Rates | Roamzy',
  metaDesc: 'One eSIM per region: live per-MB rates for every member country, one balance, no packages.',
  prerenderMarker: '.region-route',
  hydrate: () => {
    try { sessionStorage.removeItem(NAV_GUARD_KEY); } catch { /* private mode */ }
    return '';
  },
  render() {
    const ssr = ssrBodyFor('.region-route');
    if (ssr !== null) return ssr;
    try {
      if (sessionStorage.getItem(NAV_GUARD_KEY) !== browserPath()) {
        sessionStorage.setItem(NAV_GUARD_KEY, browserPath());
        window.location.assign(browserPath());
        return '';
      }
      sessionStorage.removeItem(NAV_GUARD_KEY);
    } catch {
      window.location.assign(browserPath());
      return '';
    }
    return `<section class="section"><div class="container">`
      + `<p><a href="${browserPath()}">Open the regional guide</a></p></div></section>`;
  },
};
